<template>
  <tr>
    <td
      style="padding: 10px 0"
      v-bind:class="{
        'has-error': item.HAS_UF_DATE_METTINGS_ERROR
      }"
    >
      <datepicker
        v-model="item.UF_DATE_METTINGS"
        :language="ru"
        :format="dateFormat"
        @closed="$parent.updateItem(item)"
        input-class="i-main-style t-co-executor-style"
      ></datepicker>
    </td>
    <td
      v-bind:class="{
        'has-error': item.HAS_UF_TYPE_CONTACT_ID_ERROR
      }"
      style="padding-right: 20px"
    >
      <select
        v-model="item.UF_TYPE_CONTACT_ID"
        class="sel-dropdown i-main-style"
        @change="$parent.updateItem(item)"
      >
        <option value=""></option>
        <option
          v-for="item in $parent.directory.type_present"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
    </td>
    <td
      style="padding: 10px 0"
      v-bind:class="{
        'has-error': item.HAS_UF_POSITION_ERROR
      }"
    >
      <input
        type="text"
        @change="$parent.updateItem(item)"
        v-model="item.UF_POSITION"
        class="i-main-style t-co-executor-style"
      />
    </td>
    <td
      style="padding: 10px 0"
      v-bind:class="{
        'has-error': item.HAS_UF_SURNAME_ERROR
      }"
    >
      <input
        type="text"
        @change="$parent.updateItem(item)"
        v-model="item.UF_SURNAME"
        class="i-main-style t-co-executor-style"
      />
    </td>
    <td
      style="padding: 10px 0"
      v-bind:class="{
        'has-error': item.HAS_UF_NAME_ERROR
      }"
    >
      <input
        type="text"
        @change="$parent.updateItem(item)"
        v-model="item.UF_NAME"
        class="i-main-style t-co-executor-style"
      />
    </td>
    <td
      style="padding: 10px 0"
      v-bind:class="{
        'has-error': item.HAS_UF_SECOND_NAME_ERROR
      }"
    >
      <input
        type="text"
        @change="$parent.updateItem(item)"
        v-model="item.UF_SECOND_NAME"
        class="i-main-style t-co-executor-style"
      />
    </td>
    <td
      style="padding: 10px 0"
      v-bind:class="{
        'has-error': item.HAS_UF_PHONE_ERROR
      }"
    >
      <input
        type="text"
        @change="$parent.updateItem(item)"
        v-model="item.UF_PHONE"
        class="i-main-style t-co-executor-style"
      />
    </td>
    <td
      style="padding: 10px 0"
      v-bind:class="{
        'has-error': item.HAS_UF_PHONE2_ERROR
      }"
    >
      <input
        type="text"
        @change="$parent.updateItem(item)"
        v-model="item.UF_PHONE2"
        class="i-main-style t-co-executor-style"
      />
    </td>
    <td
      style="padding: 10px 0"
      v-bind:class="{
        'has-error': item.HAS_UF_EMAIL_ERROR
      }"
    >
      <input
        type="text"
        @change="$parent.updateItem(item)"
        v-model="item.UF_EMAIL"
        class="i-main-style t-co-executor-style"
      />
    </td>

    <td>
      <a @click="$parent.deleteItem(item.ID)" class="link-delete-row"></a>
    </td>
  </tr>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { ru } from "vuejs-datepicker/dist/locale";

export default {
  data() {
    return {
      ru: ru
    };
  },
  props: ["item", "index"],
  name: "MeetingList",
  components: {
    Datepicker
  },
  methods: {
    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY");
    }
  }
};
</script>

<style scoped></style>
